import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useCatalog } from '../data/catalog';
import { useLang } from '../i18n';
import { Reveal } from './Reveal';
import { SectionHeader } from './SectionHeader';

const STATUS_STYLE = {
  available: 'bg-eco-green text-white',
  partner_network: 'bg-eco-gold text-eco-deep',
  coming_soon: 'bg-eco-ink/40 text-white',
};

export const NetworkSection = () => {
  const { t } = useLang();
  const { destinations } = useCatalog();

  return (
    <section id="destinos" data-testid="network-section" className="scroll-mt-20 bg-eco-cream py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="text-center">
          <SectionHeader
            align="center"
            eyebrow={t('net2.k')}
            title={t('net2.k')}
            text={t('net2.s')}
          />
          <Reveal delay={0.08}>
            <p className="mt-2 text-sm font-medium text-eco-gold">{t('tagline.intl')}</p>
          </Reveal>
          <Reveal delay={0.12}>
            <p data-testid="network-catalog-line" className="eco-meta mt-4 uppercase tracking-[0.14em]">{t('net.catalog')}</p>
          </Reveal>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {destinations.map((d, i) => (
            <Reveal key={d.slug} delay={i * 0.06} className={i === 0 ? 'sm:col-span-2' : ''}>
              <Link
                to={`/destinations/${d.slug}`}
                data-testid={`network-card-${d.slug}`}
                className={`group relative block h-64 overflow-hidden rounded-2xl shadow-sm transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-lg ${d.status !== 'available' ? 'opacity-90' : ''}`}
              >
                <img
                  src={d.img}
                  alt={d.name}
                  loading="lazy"
                  onError={(e) => { e.currentTarget.src = '/media/4923818b-7917-45ff-9853-4bb847436818.jpeg'; }}
                  className={`absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110 ${d.status !== 'available' ? 'grayscale-[35%]' : ''}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-eco-deep/85 via-eco-deep/20 to-transparent" />
                <span className={`absolute top-4 right-4 rounded-full px-3 py-1 text-xs font-bold tracking-wide uppercase ${STATUS_STYLE[d.status]}`} data-testid={`network-status-${d.slug}`}>
                  {t(`dst.${d.status === 'partner_network' ? 'partner' : d.status}`)}
                </span>
                <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-5">
                  <div>
                    <p className="flex items-center gap-2 text-xl leading-tight font-bold tracking-[-0.02em] text-white">
                      <img src={`https://flagcdn.com/20x15/${d.flag}.png`} alt="" width="20" height="15" className="rounded-[2px]" />
                      {d.name}
                    </p>
                    <p className="mt-0.5 line-clamp-1 text-xs text-white/65">{d.positioning}</p>
                  </div>
                  <ArrowRight size={16} className="shrink-0 text-eco-gold transition-transform duration-300 group-hover:translate-x-1" />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
